export const filterSelectorState = group => selectorName => {
  const key = `${group}/${selectorName}`;
  const relatedKey = `${group}/${selectorName.endsWith( ' Fixed Parts' ) 
    ? selectorName.replace( /\ Fixed Parts$/, '' ) 
    : `${selectorName} Fixed Parts`}`;

  return state => {
    const filterSelectors = state.filterSelectors[key];
    let relatedFilterSelectors = filterSelectors && state.filterSelectors[relatedKey];
  
    if( filterSelectors && relatedFilterSelectors ) {
      relatedFilterSelectors = relatedFilterSelectors.filter( relatedFilter => 
        filterSelectors.any( filter => {
          return filter.identifier === relatedFilter.identifier && 
                                       filter.name.trim().toLowerCase() === relatedFilter.name.trim().toLowerCase() && 
                                       filter.values.any( value => relatedFilter.values.firstOrDefault( relatedValue => relatedValue.name === value.name ) ); 
        } )
      );
    }

    return { filterSelectors, selectorName, relatedFilterSelectors };
  };
};